<template>
  <div>
    <!-- 学校排名 -->
    <div class="rank-table">
      <dv-scroll-board :config="tableData" class="scroll-board" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      tableData: {},
      list: []
    };
  },
  watch: {
    dataList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.schoolInfo();
        }
      },
      immediate: true
    }
  },
  methods: {
    async schoolInfo() {
      this.tableData = {
        header: ['学校', '活跃度', '排名'],
        data: this.dataList,
        headerHeight: '70',
        align: ['center', 'center', 'center']
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.rank-table {
  width: 432px;
  height: 333px;
  padding: 0px 6px;
  background-image: url(~@/assets/images/table-bg.png);
  .scroll-board {
    width: 100%;
    height: 327px;
    ::v-deep {
      .header {
        background-color: transparent !important;
        font-size: 20px;
        font-weight: 500;
        color: #ffcc00;
      }
      .rows {
        .row-item {
          font-weight: 300;
          font-size: 16px;
          background-color: transparent !important;
        }
        .row-item:nth-child(odd) {
          box-shadow: inset 0px 0px 10px 0px #fff;
        }
      }
    }
  }
}
</style>
